import { useRef, useState } from 'react'
import { PortableText } from '@portabletext/react'
import { portableBlockComponents } from '@/utils/portableText'
import s from './Credits.module.scss'

interface DataProps {
    _type: string;
    _ref: string;
    column: any;
}

interface Credits {
    credits: DataProps | null;
    bua: string | null;
    status: string | null;
    client: string | null;
    location: string | null;
    year: string | null;
    color: string | null;
}

export default function CreditsOnTopComponent({
    credits,
    bua,
    status,
    client,
    location,
    year,
    color
}: Credits) {
    const [openedCredits, setOpenedCredits] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    return (
        <section className={s.creditsAll}>
            <div
                ref={contentRef}
                className={`${s.credits} ${openedCredits ? s.opened : ''} ${color && color == 'white' ? s.white : s.black}`}
                style={{
                    maxHeight: openedCredits ? `${(contentRef.current?.scrollHeight ?? 0 + 30)}px` : '0px',
                }}
            >
                <div className={s.creditsInner}>
                <div className={s.col}>
                    {location && (
                        <div className={s.row}>
                            <p>LOCATION</p>
                            <p>{location}</p>
                        </div>
                    )}
                    {client && (
                        <div className={s.row}>
                            <p>CLIENT</p>
                            <p>{client}</p>
                        </div>
                    )}
                </div>
                <div className={s.col}>
                    {year && (
                        <div className={s.row}>
                            <p>YEAR</p>
                            <p>{year}</p>
                        </div>
                    )}
                    {status && (
                        <div className={s.row}>
                            <p>STATUS</p>
                            <p>{status}</p>
                        </div>
                    )}
                    {bua && (
                        <div className={s.row}>
                            <p>BUA</p>
                            <p>{bua}</p>
                        </div>
                    )}
                </div>
                {credits && credits.column.length > 0 &&
                    credits.column.map((creditList: any, index: number) => (
                        <div key={`column-${index}`} className={s.col}>
                            {creditList && creditList.credits.length > 0 && creditList.credits.map((credit: any, i: number) => (
                                <div className={s.row} key={`credit-${index}-${i}`}>
                                    <p>{credit.title && credit.title}</p>
                                    {credit.names && (
                                        <PortableText
                                            value={credit.names}
                                            components={portableBlockComponents(credit.names)}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            <div className={s.clickOpen} onClick={() => setOpenedCredits(!openedCredits)}>
                <p>{openedCredits ? 'HIDE CREDITS' : 'SEE CREDITS'}</p>
            </div>
        </section>
    );
}